/** BoneConstraint3D parser: the SkeletonModifier3D parse plus the base `settings/<i>/` leaves. */
import { parseSkeletonModifier3D } from '../skeletonmodifier3d/parser';
import { newConstraintSetting, readConstraintSettings } from './settings';
export function parseBoneConstraint3D(heading, properties) {
    return {
        ...parseSkeletonModifier3D(heading, properties),
        settings: readConstraintSettings(properties, newConstraintSetting, {}),
    };
}
//# sourceMappingURL=parser.js.map